import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, PropertyValues, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './ghs-tab-nav.css.lit';
import { MobileController } from '../../controllers/mobile-controller';

/**
 * The Tab Nav component
 *
 * @element ghs-tab-nav
 */
@customElement('ghs-tab-nav')
export class GhsTabNav extends OutlineElement {
  private mobileController = new MobileController(this);
  static styles: CSSResultGroup = [componentStyles];

  /**
   * The label text.
   * @param label
   */
  @property({ type: String })
  label = '';

  /**
   * Whether the panel is active/open.
   * Controlled by parent ghs-tabs component.
   */
  @property({ type: Boolean, reflect: true })
  active = false;

  /**
   * Used to provided a unique ID
   * for ghs-tabs component and accessibility purposes.
   */
  @property({ type: String, attribute: 'unique-id', reflect: true })
  uniqueId: string = Math.floor(Math.random() * 10000).toString();

  /**
   * The variant.
   * @param variant
   */
  @property({ type: String })
  variant = 'default';

  @state() isOpen = false;

  setNavAttributes(): void {
    this.setAttribute('aria-selected', this.active ? 'true' : 'false');
    this.setAttribute('aria-controls', `${this.uniqueId}-info`);
    this.setAttribute('id', `${this.uniqueId}-button`);
    this.setAttribute('role', 'tab');
    this.setAttribute('type', 'button');
  }

  protected update(changedProperties: PropertyValues) {
    this.setNavAttributes();
    super.update(changedProperties);
  }

  render(): TemplateResult {
    const isMobile = this.mobileController.isMobile ? 'is-mobile' : null;
    const isActive = this.active ? 'active' : 'inactive';

    return html`
      <div class="tab-nav tab-nav--${this.variant} ${isMobile} ${isActive}">
        ${this.label}
      </div>
    `;
  }
}
